import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
});

// Adicionar token automaticamente
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Serviço para gerenciar saldos iniciais de projetos
const projectInitialBalanceService = {
  // Listar todos os saldos de um projeto
  getBalances: (projectId) => {
    return api.get(`/projects/${projectId}/initial-balances`);
  },

  // Criar novo saldo inicial
  createBalance: (projectId, data) => {
    return api.post(`/projects/${projectId}/initial-balances`, data);
  },

  // Atualizar saldo inicial
  updateBalance: (projectId, balanceId, data) => {
    return api.put(`/projects/${projectId}/initial-balances/${balanceId}`, data);
  },

  // Deletar saldo inicial
  deleteBalance: (projectId, balanceId) => {
    return api.delete(`/projects/${projectId}/initial-balances/${balanceId}`);
  },

  // Atualizar status do saldo
  updateStatus: (projectId, balanceId, status) => {
    return api.patch(`/projects/${projectId}/initial-balances/${balanceId}/status`, { status });
  },

  // Buscar entradas financeiras geradas por um saldo inicial
  getEntries: (projectId, balanceId) => {
    return api.get(`/projects/${projectId}/initial-balances/${balanceId}/entries`);
  },

  // Importação em lote de saldos iniciais
  bulkCreate: (balances) => {
    return api.post('/projects/initial-balances/bulk', { balances });
  },

  // Confirmar recebimento de parcela (cria cashbox transaction)
  confirmParcelReceipt: (projectId, balanceId, incomeId) => {
    return api.post(`/projects/${projectId}/initial-balances/${balanceId}/confirm-parcel`, { incomeId });
  },

  // FEATURE 02: Confirmar recebimento com valor diferente (DEFICIT/SURPLUS)
  confirmParcelReceiptRefactored: (projectId, balanceId, data) => {
    return api.post(`/projects/${projectId}/initial-balances/${balanceId}/confirm-parcel-refactored`, data);
  },

  // FEATURE 01: Desconfirmar/reverter recebimento de parcela
  unconfirmParcelReceipt: (projectId, balanceId, data) => {
    return api.post(`/projects/${projectId}/initial-balances/${balanceId}/unconfirm-parcel`, data);
  },

  // FEATURE 03: Alterar data de vencimento de parcela
  changeParcelDueDate: (projectId, balanceId, data) => {
    return api.put(`/projects/${projectId}/initial-balances/${balanceId}/change-due-date`, data);
  },

  // Alternar status de cheque recebido em mãos (posse física do cheque pré-datado)
  toggleChequeInHand: (projectId, balanceId, data) => {
    return api.put(`/projects/${projectId}/initial-balances/${balanceId}/toggle-cheque-in-hand`, data);
  },

  // Adicionar parcela de entrada extra
  addEntrySplit: (projectId, balanceId, splitData) => {
    return api.post(`/projects/${projectId}/initial-balances/${balanceId}/entry-split`, splitData);
  },

  // Recalcular valores das parcelas pendentes com base nos ajustes
  recalculateExpectedAmounts: (projectId, balanceId) => {
    return api.post(`/projects/${projectId}/initial-balances/${balanceId}/recalculate`);
  },

  // Ajuste de divergência - redistribui valores das parcelas pendentes
  adjustInstallmentAmounts: (projectId, balanceId) => {
    return api.post(`/projects/${projectId}/initial-balances/${balanceId}/adjust`);
  },

  // Aplicar desconto em parcela específica
  applyDiscount: (projectId, balanceId, data) => {
    return api.post(`/projects/${projectId}/initial-balances/${balanceId}/apply-discount`, data);
  },

  // Confirmar todas as parcelas de cartão em lote
  confirmAllCardInstallments: (projectId, balanceId) => {
    return api.post(`/projects/${projectId}/initial-balances/${balanceId}/confirm-all-card`);
  },
};

export default projectInitialBalanceService;
